import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { GeneratedContentDestroyInput, GeneratedContentDestroyPayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = GeneratedContentDestroyInput;
type TData = GeneratedContentDestroyPayload;

export const useContentGenerationDelete = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation generatedContentDestroy($input: GeneratedContentDestroyInput!) {
      generatedContentDestroy(input: $input) {
        success
        errors
        errorCode
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
